import { useEffect, useRef } from "react";

/**
 * Return previous state of a react useState variable
 * @param { any } value state
 * @returns previous state
 */
export const usePreviousState = (value: any) => {
    const ref = useRef();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current ?? value; // if previous state is undefined return current
};
